<h2 class="bd-title">Script Editor</h2>
<button
  type="button"
  id="scriptTesterLauncherButton"
  class="btn btn-info mb-3"
  data-toggle="tooltip"
  data-placement="top"
  data-original-title="Run your LUA script to confirm that no errors exist"
  (click)="openScriptTester()"
  [disabled]="isReadOnly$ | async"
>
  <span class="fa fa-code mr-1" aria-hidden="true"></span>Script Tester
</button>

@if (isEditorLoading) {
<div class="editor-loading"><span class="fa fa-spinner fa-spin mr-1" aria-hidden="true"></span>The editor is being loaded. Please wait...</div>
}

<div class="editor-container">
  <ngx-monaco-editor
    id="customScript"
    name="customScript"
    [formControl]="formGroup.controls.customScript"
    [options]="editorOptions"
    (init)="onMonacoInit($event)"
    triggers="focus"
    popoverTitle="Custom Script"
    [popover]="customScriptPopover"
    placement="right"
  ></ngx-monaco-editor>
</div>

<ng-template #customScriptPopover>
  <p>The interpreter for the LUA language.</p>
  <p>Your script must contain at least one of the following functions:</p>
  <p><code class="text-primary">getLibraryName()</code>, which must return the name for the SharePoint document library to be created</p>
  <p><code class="text-primary">getFolderName()</code>, which must return the name for the SharePoint folder to be created.</p>
  <p><code class="text-primary">getParentField()</code>, which must return false (default), nil or fieldname. Used to resolve Parent location.</p>
  <p><code class="text-primary">getSite()</code>, which must return an object with a specific id and URI. Used to resolve SharePoint site.</p>
  <p><code class="text-primary">getSiteCollection()</code>, which must return an object with a specific id and URI. Used to resolve SharePoint site collection.</p>
  <p><code class="text-primary">getSubfolders()</code>, which must return an array of folders (as strings) that should be created in target document location.</p>
</ng-template>
